import { Controller } from "stimulus"

// Manages the toggle between message and date input for bathing reset date
export default class extends Controller {
  static targets = ["messageContainer", "inputContainer", "dateInput"]
  
  connect() {
    console.log('bathing-reset controller connected');
    
    // Add click listener to document for handling clicks outside
    document.addEventListener('click', this.handleClickOutside.bind(this));
    
    // Add blur handler to date input
    if (this.hasDateInputTarget) {
      this.dateInputTarget.addEventListener('blur', (event) => {
        setTimeout(() => {
          const value = this.dateInputTarget.value;
          if (!value || value.trim() === '') {
            const calendar = document.querySelector('.flatpickr-calendar.open');
            if (!calendar) {
              this.showMessage();
            }
          }
        }, 200);
      });
    }
    
    // Setup flatpickr hook
    if (this.hasDateInputTarget) {
      setTimeout(() => {
        const input = this.dateInputTarget;
        if (input && input._flatpickr) {
          input._flatpickr.config.onClose = () => {
            this._flatpickrClosed();
          };
        }
      }, 500);
    }
  }
  
  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }
  
  handleClickOutside(event) {
    if (!this.hasAllTargets()) return;
    
    // Only process if input is visible
    if (!this.inputContainerTarget.classList.contains('d-none')) {
      const clickedElement = event.target;
      const dateInputElement = this.dateInputTarget;
      const dateInputContainer = dateInputElement.closest('.position-relative');
      
      const isOnInput = dateInputElement === clickedElement || dateInputElement.contains(clickedElement);
      const isOnInputContainer = dateInputContainer === clickedElement || dateInputContainer.contains(clickedElement);
      const isOnFlatpickr = !!document.querySelector('.flatpickr-calendar')?.contains(clickedElement);
      
      if (!isOnInput && !isOnInputContainer && !isOnFlatpickr) {
        const inputValue = this.dateInputTarget.value;
        if (!inputValue || inputValue.trim() === '') {
          this.showMessage();
        }
      }
    }
  }

  toggleInput(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (!this.hasAllTargets()) return;
    
    this.showInput();
    setTimeout(() => {
      if (this.hasDateInputTarget) {
        this.dateInputTarget.focus();
        if (this.dateInputTarget._flatpickr) {
          this.dateInputTarget._flatpickr.open();
        }
      }
    }, 50);
  }
  
  showInput() {
    if (!this.hasAllTargets()) return;
    
    this.messageContainerTarget.classList.add('d-none');
    this.inputContainerTarget.classList.remove('d-none');
  }
  
  showMessage() {
    if (!this.hasAllTargets()) return;
    
    this.messageContainerTarget.classList.remove('d-none');
    this.inputContainerTarget.classList.add('d-none');
  }
  
  checkEmpty(event) {
    if (!this.hasAllTargets()) return;
    
    const value = this.dateInputTarget.value;
    if (!value || value.trim() === '') {
      setTimeout(() => {
        const calendar = document.querySelector('.flatpickr-calendar');
        if (!calendar || !calendar.classList.contains('open')) {
          this.showMessage();
        }
      }, 200);
    }
  }
  
  _flatpickrClosed() {
    if (!this.hasAllTargets()) return;
    
    const value = this.dateInputTarget.value;
    if (!value || value.trim() === '') {
      this.showMessage();
    }
  }
  
  hasAllTargets() {
    return this.hasInputContainerTarget && this.hasMessageContainerTarget && this.hasDateInputTarget;
  }
} 